import React from 'react';

const EvoMLUseCases = () => {
  const useCases = [
    {
      title: 'Automated Model Selection',
      description: 'EvoML automatically selects the best machine learning models for your specific use case',
      icon: '🎯'
    },
    {
      title: 'Hyperparameter Optimization',
      description: 'Intelligent tuning of model parameters using evolutionary algorithms',
      icon: '⚙️'
    },
    {
      title: 'Feature Engineering',
      description: 'Automated feature creation and selection for improved model performance',
      icon: '🔧'
    },
    {
      title: 'Model Ensemble Creation',
      description: 'Combining multiple models for better predictions',
      icon: '🤝'
    }
  ];

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
      <h1 style={{ fontSize: '2.5em', marginBottom: '20px', color: '#333' }}>
        EvoML Use Cases
      </h1>
      <p style={{ fontSize: '1.2em', color: '#666', marginBottom: '40px' }}>
        Discover how EvoML can transform your machine learning workflows
      </p>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
        gap: '30px',
        marginTop: '40px'
      }}>
        {useCases.map((useCase, index) => (
          <div key={index} style={{
            background: '#f8f9fa',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            transition: 'transform 0.2s',
            cursor: 'pointer',
            ':hover': {
              transform: 'translateY(-5px)'
            }
          }}>
            <div style={{ fontSize: '3em', marginBottom: '20px' }}>{useCase.icon}</div>
            <h3 style={{ fontSize: '1.5em', marginBottom: '15px', color: '#333' }}>
              {useCase.title}
            </h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              {useCase.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EvoMLUseCases; 